import {Component, OnInit, ViewChild} from '@angular/core';
import {Geolocation} from '@ionic-native/geolocation';
import {Location, Sector, Site} from "../../models/data.model";
import {DataProvider} from "../../providers/data/data";
import {ToastProvider} from "../../providers/toast/toast";
import {RestProvider} from "../../providers/rest/rest";
import {MapComponent, Point} from "@yaga/leaflet-ng2";
import * as L from 'leaflet';
import {CircleMarker} from "leaflet";

@Component({
  selector: 'page-map',
  templateUrl: 'map.html'
})
export class MapPage {

  center : Location = {
    latitude: 44.743493,
    longitude: 6.757212
  };
  siteIdSelected: number = -1;
  sectorIdSelected: number = -1;
  zoom: number = 10;
  @ViewChild(MapComponent) map: MapComponent;
  poiIconSize: number = 30;
  popupAnchor: Point = new Point(0, -20);
  size: Point = new Point(this.poiIconSize,this.poiIconSize);
  markerUrl: string = "assets/marker/";
  markerUser = L.circleMarker([this.center.latitude, this.center.longitude]);

  constructor(
    private geolocation : Geolocation,
    public toast: ToastProvider,
    private data: DataProvider) {
    this.geolocation.watchPosition().subscribe(value => {
      this.markerUser.setLatLng([value.coords.latitude, value.coords.longitude])
    })
  }

  protected isParking(sector: Sector): boolean {
    return sector.parking
      && sector.parking.latitude != null
      && sector.parking.longitude != null;
  }

  protected getParkingIcon() : string {
    return this.markerUrl + "marker-parking.png";
  }

  protected getSites(): Site[] {
    return this.data.getSites();
  }

  protected getMarkerOrange(): string {
    return RestProvider.getMarkerOrange();
  }

  protected openSiteInfo(site: Site) {
    this.siteIdSelected = site.id;
    this.sectorIdSelected = -1;
  }

  protected openSectorInfo(siteId: number, sectorId: number) {
    this.siteIdSelected = siteId;
    this.sectorIdSelected = sectorId;
  }

  protected closeInfo() {
    this.siteIdSelected = -1;
    this.sectorIdSelected = -1;
  }

  protected isSiteSelected(): Boolean {
    return this.siteIdSelected !== -1 && this.sectorIdSelected === -1;
  }

  protected isSectorSelected() {
    return this.siteIdSelected !== -1 && this.sectorIdSelected !== -1;
  }

  protected updateLocation() {
    this.data.updateLocation()
      .then(() => {
        if (this.data.getLocation() != null) {
          let location: Location = this.data.getLocation();
          this.map.setView({
            lat: this.markerUser.getLatLng().lat,
            lng: this.markerUser.getLatLng().lng
          }, 12);
        }
      }).catch(err => {
        this.toast.errorToast("Localisation indisponible");
      });
  }

}



// WEBPACK FOOTER //
// ./src/pages/map/map.ts